import { imputationDocumentId } from '../pages/review-expense/utils/contract-expense-json';

/**
 * Office label for Selects: `{name} - {alias}` when aliases exist (non-empty),
 * otherwise `name` (or Mongo id string if name missing).
 * Multiple aliases are joined with ", " (same as admin Offices table).
 */
export function officeNameWithAliasesLabel(office) {
    if (!office) return '';
    const id = imputationDocumentId({ _id: office._id });
    const name = office.name != null && office.name !== '' ? String(office.name) : id;
    const parts = Array.isArray(office.alias)
        ? office.alias.map((a) => (a == null ? '' : String(a).trim())).filter(Boolean)
        : [];
    const aliasStr = parts.join(', ');
    if (!aliasStr) return name;
    return `${name} - ${aliasStr}`;
}
